export const BADEN_WUERTTEMBERG = 1;
export const BAVARIA = 2;
export const BERLIN = 3;
export const BRANDENBURG = 4;
export const BREMEN = 5;
export const HAMBURG = 6;
export const HESSE = 7;
export const MECKLENBURG_WEST_POMERANIA = 8;
export const LOWER_SAXONY = 9;
export const NORTH_RHINE_WESTPHALIA = 10;
export const RHINELAND_PALATINATE = 11;
export const SAARLAND = 12;
export const SAXONY = 13;
export const SAXONY_ANHALT = 14;
export const SCHLESWIG_HOLSTEIN = 15;
export const THURINGIA = 16;
